module.exports = __webpack_public_path__ + "images/category_lp/common/reason2-watch_0ba8b5dc4fcc36592cc8602172e68f52.jpg";